import authApi from '@/api/authApi'
import Vue from 'vue'
export default {
  namespaced: true,

  state: {
    drawer: true,
    loading: null
  },
  getters: {},
  mutations: {
    SET_DRAWER (state, value) {
      state.drawer = value
    },
    SET_LOADING (state, value) {
      state.loading = value
    }
  },
  actions: {
    async csrf ({ commit }) {
      commit('SET_LOADING', true)
      await authApi.csrfCookie()
      commit('SET_LOADING', false)
    },
    async init ({ commit }) {
      commit('SET_LOADING', true)
      await authApi.csrfCookie()
      try {
        const response = await authApi.user()
        const user = response.data
        Vue.$log.info('user auth', [user])
        if (user) {
          commit('auth/SET_AUTHENTICATED', true, { root: true })
          commit('auth/SET_USER', user, { root: true })
          localStorage.setItem('isLoggedIn', true)
        } else {
          commit('auth/SET_AUTHENTICATED', false, { root: true })
          commit('auth/SET_USER', null, { root: true })
        }
      } finally {
        commit('SET_LOADING', false)
      }
    }
  }
}
